(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('AddCAF', AddCAF);

    AddCAF.$inject = ['$resource'];

    function AddCAF ($resource) {
        var resourceUrl =  '/api/addcaf';


        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'verifyPan': {
                method: 'POST',
                url: '/api/verifyPan',
                transformResponse: function (data) {
                    return data; // Return the raw response (string)
                }
            }
        });
    }
})();
